import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
export class DocumentViewerComponent extends BaseManagement {
    constructor(mainService, translate, ngxService, transactionService) {
        super();
        this.mainService = mainService;
        this.translate = translate;
        this.ngxService = ngxService;
        this.transactionService = transactionService;
        this.validateForm = false;
        this.isPDF = false;
        this.serverError = '';
        this.isFormValid = false;
        /** Solo mostrar el PDF cuando formData ya esté preparado, para evitar campos en blanco por race condition */
        this.formDataReady = false;
    }
    checkIfPDF() {
        if (typeof this.mainService.fileToLoad === 'string') {
            let extension = this.getFileExtension(this.mainService.fileToLoad);
            this.isPDF = extension.toLowerCase() === 'pdf';
        }
    }
    getFileExtension(fileName) {
        const parts = fileName.split('.');
        return parts[parts.length - 1];
    }
    ngOnInit() {
        this.checkIfPDF();
        console.log('validateForm:', this.validateForm);
        console.log(this.mainService.currentRequirement && this.mainService.currentRequirement.PdfFormJson);
        console.log('this.mainService.fileToLoad: ' + this.mainService.fileToLoad);
        console.log(this.transactionService.itemToEdit.AssignedToCurrentUser);
        // Asegurar que formData esté listo antes de mostrar el PDF (evita campos en blanco)
        this.patchPdfFormData();
        // Un tick para que formData esté estable antes de crear el viewer
        setTimeout(() => this.formDataReady = true, 0);
        // Validate form after patching data
        setTimeout(() => {
            this.validateFormManually();
        }, 1000); // Wait for PDF viewer to load
    }
    patchPdfFormData() {
        if (this.mainService.currentRequirement && this.mainService.currentRequirement.PdfFormJson) {
            try {
                const formData = JSON.parse(this.mainService.currentRequirement.PdfFormJson);
                this.mainService.formData = formData;
                console.log('PDF form data patched:', formData);
            }
            catch (error) {
                console.error('Error parsing PdfFormJson:', error);
            }
        }
        else {
            // Sin PdfFormJson, empezar con objeto vacío para que el viewer tenga estado conocido
            this.mainService.formData = {};
        }
    }
    // Manual validation method
    validateFormManually() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('validateFormManually called, validateForm:', this.validateForm);
            if (!this.validateForm) {
                this.isFormValid = true;
                console.log('Validation disabled, setting isFormValid to true');
                return;
            }
            try {
                const formData = yield this.ngxService.getFormData();
                console.log('Form data retrieved:', formData);
                const missingFields = [];
                for (const field of formData) {
                    const fieldValue = field.fieldAnnotation && field.fieldAnnotation.value ? field.fieldAnnotation.value : '';
                    console.log('Checking field:', field.name, 'value:', fieldValue);
                    // Check if field name contains "required" and if the field is empty
                    if (field.name && field.name.toLowerCase().includes('required')) {
                        const isEmpty = !fieldValue || fieldValue.trim() === '';
                        console.log('Required field:', field.name, 'isEmpty:', isEmpty);
                        if (isEmpty) {
                            missingFields.push(field.name);
                        }
                    }
                }
                this.isFormValid = missingFields.length === 0;
                console.log('Missing fields:', missingFields);
                console.log('isFormValid:', this.isFormValid);
            }
            catch (error) {
                console.error('Error during form validation:', error);
                this.isFormValid = false;
            }
        });
    }
    close() {
        this.mainService.fileToLoad = null;
    }
    tryUpdateFormData(action) {
        console.log('tryUpdateFormData called, isFormValid:', this.isFormValid);
        if (!this.isFormValid) {
            this.alertCompleteForm();
            return;
        }
        if (this.isSaving())
            return;
        this.translate
            .get([
            'message.deleteConfirmText',
            'message.yes',
            'message.no',
            'message.requirement',
            'message.deleted',
            'message.unableRequirement',
            'message.done',
            'pdfform.saveWarn',
        ])
            .subscribe((translations) => {
            const dialogRef = this.dialog.open(DialogYesNoComponent, {
                width: '250px',
                data: {
                    msg: translations['pdfform.saveWarn'],
                    yesText: translations['message.yes'],
                    noText: translations['message.no'],
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 1) {
                    this.startSaving(action);
                    this.updateFormData(action);
                }
            });
        });
    }
    updateFormData(action) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var formData = new FormData();
            var files = [];
            Array.from(files).forEach((f) => formData.append('file', f));
            let params = [];
            params.userProcessId = this.mainService.currentRequirement.ProcessId;
            params.userProcessRequirementId = this.mainService.currentRequirement.UserProcessRequirementId;
            // Convertir saltos de línea a etiquetas HTML <br>
            console.log('📋 Datos originales:', this.mainService.formData);
            const sanitizedFormData = this.convertNewLinesToHtml(this.mainService.formData);
            console.log('✅ Datos con <br>:', sanitizedFormData);
            formData.append('pdfFormJson', JSON.stringify(sanitizedFormData));
            this.mainService.updatePdfFormInternal(params, formData)
                .then((updatedRequirement) => {
                // this.mainService.pdfCommunicator.next("stop-saving");
                this.stopSaving();
                this.mainService.currentRequirement = updatedRequirement.Data;
                this.mainService.updateItemByField(this.mainService.currentRequirement.UserProcessRequirementId, 'UserProcessRequirementId', this.mainService.currentRequirement);
                this.close();
            })
                .catch((err) => {
                console.log('error', err);
                this.translate
                    .get(['error.documentUplaod'])
                    .subscribe((translations) => {
                    this.stopSaving();
                    this.serverError = "Hubo un problema al intentar enviar el documento";
                });
            });
        });
    }
    onFormChange(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('onFormChange triggered');
            yield this.validateFormManually();
        });
    }
    alertCompleteForm() {
        const dialogRef = this.dialog.open(DialogOkComponent, {
            data: {
                msg: 'Rellene todos los campos obligatorios.',
            }
        });
        dialogRef.afterClosed().subscribe((res) => { });
    }
    /**
     * Convierte los saltos de línea (\n) a etiquetas HTML <br> para que se
     * muestren correctamente en el PDF generado
     * @param data Objeto con los datos del formulario
     * @returns Objeto con los datos convertidos
     */
    convertNewLinesToHtml(data) {
        const converted = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                let value = data[key];
                // Si es un string, convertir saltos de línea a <br>
                if (typeof value === 'string') {
                    // Normalizar diferentes tipos de saltos de línea
                    value = value.replace(/\r\n/g, '\n'); // Windows
                    value = value.replace(/\r/g, '\n'); // Mac antiguo
                    // Convertir \n a <br>
                    value = value.replace(/\n/g, '<br>');
                }
                converted[key] = value;
            }
        }
        return converted;
    }
}
